import React, { FC } from 'react'
import { format } from '@dt/fe-utils'
import { cartMobx, orderMobx } from 'restaurant'
import './index.scss'

interface IProps {
  orderItem: IViewCombinedOrderDetail;
  eatType: 'dinein' | 'togo' | 'delivery' | 'pickup' | 'mall' | 'redeemCouponByMoney' | 'carside';
}

const OrderYellowTitleBar: FC<IProps> = ({ orderItem, eatType }) => {
  const isPickup = eatType === 'pickup'
  return (
    <div className='yellow-title'>
      <div className='title'>{isPickup && orderMobx.viewOrder.nono ? `${i18n.t('result.nono2')}: ${orderMobx.viewOrder.nono}` : i18n.t('cart.allProductOrder')}</div>
      <span className='desc'>{i18n.t(`cart.${isPickup ? 'pickupOrderTime' : 'allProductOrderTime'}`, { time: format.toDateTime(orderItem.addTime) })}</span>
    </div>
  )
}

export default OrderYellowTitleBar
